import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';

import {
  heroSectionBodySx,
  heroSectionButtonSx,
  heroSectionRootSx,
  heroSectionTitleSx,
} from './HeroSection.styles';

function HeroSection() {
  return (
    <Stack spacing={3} alignItems="center" textAlign="center" sx={heroSectionRootSx}>
      <Typography variant="h2" component="h1" color="primary" sx={heroSectionTitleSx}>
        🔮 Welcome, Seeker
      </Typography>
      <Typography variant="body1" sx={heroSectionBodySx}>
        Choose a tarot spread, shuffle the full 78-card deck, and select the cards that speak to
        you. Let the wisdom of the cards guide your journey.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        component={RouterLink}
        to="/reading"
        sx={heroSectionButtonSx}
      >
        Begin a Reading
      </Button>
    </Stack>
  );
}

export default HeroSection;
